import { RefObject, useEffect, useLayoutEffect, useState } from "react";

const useDomRect = (ref) => {
  const [domRect, setDomRect] = useState(null);

  useLayoutEffect(() => {
    setDomRect(ref?.current && ref.current.getBoundingClientRect());
  }, []);

  useEffect(() => {
    const scrollHandler = () => {
      setDomRect(ref?.current && ref.current.getBoundingClientRect());
    };
    window.addEventListener("scroll", scrollHandler, true);
    return () => {
      window.removeEventListener("scroll", scrollHandler, true);
    };
  }, []);

  return [domRect];
};

export default useDomRect;
